import React from 'react';

import { BaseCardProps } from '../types';

const CardProfile: React.FC<Pick<BaseCardProps, 'profile'>> = (props) => {
  const { profile } = props;

  if (!profile) {
    return null;
  }

  return (
    <div className="Card__profile__wrapper">
      <div className="Card__profile">
        {profile.image && <img src={profile.image} alt={profile.name} />}
        <p className="body--small">{profile.name}</p>
      </div>
    </div>
  );
};

export default CardProfile;
